import { useGetExamEventMetadataByCardId } from '@exam-room/graphql';
import { useMemo } from 'react';

export enum QuestionnaireTemplateId {
  TemplateA = 'TEMPLATE_A',
  TemplateB = 'TEMPLATE_B',
  TemplateC = 'TEMPLATE_C',
}
interface UseGetExamEventSettingsProps {
  cardId: string;
}

interface ResultSettings {
  display: boolean;
  delayedDays: number;
  hasCertificate: boolean;
}

interface ExamEventSettings {
  result: ResultSettings;
  questionnaire: QuestionnaireTemplateId | null;
}

const QUESTIONNAIRE_TEMPLATES = Object.values(QuestionnaireTemplateId);

interface UseGetExamEventSettingsReturn {
  settings: ExamEventSettings;
  isLoading: boolean;
}
export function useGetExamEventSettings(
  props: Readonly<UseGetExamEventSettingsProps>,
): UseGetExamEventSettingsReturn {
  const { cardId } = props;
  const { loading: isLoading, data } = useGetExamEventMetadataByCardId({ variables: { cardId } });

  const examEventSettings = data?.erGetExamEventByCardId?.metadata;
  const examResultSettings = data?.erGetExamEventByCardId?.metadata?.result;

  const settings = useMemo(
    () => ({
      display: examResultSettings?.display ?? false,
      delayedDays: examResultSettings?.delayedDays ?? 0,
      hasCertificate: examResultSettings?.hasCertificate ?? false,
      result: {
        display: examResultSettings?.display ?? false,
        delayedDays: examResultSettings?.delayedDays ?? 0,
        hasCertificate: examResultSettings?.hasCertificate ?? false,
      },
      questionnaire: QUESTIONNAIRE_TEMPLATES.includes(examEventSettings?.questionnaire)
        ? examEventSettings?.questionnaire
        : null,
    }),
    [examEventSettings, examResultSettings],
  );

  return { isLoading, settings };
}
